<div *ngIf="col.format || col.routeLink; else appRenderer">
  <ng-container *ngVar="col.subfield ?  row?.[col.field]?.[col.subfield] : row?.[col.field] as field;">
    <!--            ngModel cannot be applied on template variables, hence using explicit conditions for subfields-->
    <div *ngIf="col.format === TableFormat.BooleanAsReadOnlyInputSwitch && !col.subfield" class="input-switch-display-only">
      <p-selectButton [options]="viewOptions" [(ngModel)]="row[col.field]" [disabled]="true"></p-selectButton>
    </div>
    <div *ngIf="col.format === TableFormat.BooleanAsReadOnlyInputSwitch && col.subfield" class="input-switch-display-only">
      <p-selectButton [options]="viewOptions" [(ngModel)]="row[col.field][col.subfield]" [disabled]="true"></p-selectButton>
    </div>
    <div *ngIf="col.format === TableFormat.BooleanAsWritableInputSwitch && !col.subfield" class="input-switch-display-only">
      <p-selectButton [options]="viewOptions" [(ngModel)]="row[col.field]" ></p-selectButton>
    </div>
    <div *ngIf="col.format === TableFormat.BooleanAsWritableInputSwitch && col.subfield" class="input-switch-display-only">
      <p-selectButton [options]="viewOptions" [(ngModel)]="row[col.field][col.subfield]" ></p-selectButton>
    </div>
    <div *ngIf="col.format === TableFormat.BooleanAsReadOnlyCheckbox && !col.subfield" class="checkbox-column">
      <p-checkbox [binary]="true" [(ngModel)]="row[col.field]" [disabled]="true"></p-checkbox>
    </div>
    <div *ngIf="col.format === TableFormat.BooleanAsReadOnlyCheckbox && col.subfield" class="checkbox-column">
      <p-checkbox [binary]="true" [(ngModel)]="row[col.field][col.subfield]" [disabled]="true"></p-checkbox>
    </div>
    <div *ngIf="col.format === TableFormat.CheckOrBanAndValue">
      <span *ngIf="field==='true'">
        <i class="fa fa-check-circle" style="color:green" aria-hidden="true"></i>
      </span>
      <span *ngIf="field==='false'">
        <i class="fa fa-ban" style="color:red" aria-hidden="true"></i>
      </span>
      <span *ngIf="field!=='true'&& field!=='false' && field!=='null' && field!==null" && field!=='$null'>
        {{field}}
      </span>
    </div>
    <div *ngIf="col.format === TableFormat.Currency" [class]="ClassType.CurrencyInTable">
      {{field | currency:Format.Currency}}
    </div>
    <div *ngIf="col.format === TableFormat.CurrencyNegative" [class]="ClassType.CurrencyInTable">
      {{field | currency:Format.Currency | negativeCurrency}}
    </div>
    <div *ngIf="col.format === TableFormat.Number" [class]="ClassType.CurrencyInTable">
      {{field}}
    </div>
    <div *ngIf="col.format === TableFormat.CurrencyBold" [class]="ClassType.CurrencyInTable">
      <span *ngIf="!row[col.boldField]"><strong>{{field | currency:Format.Currency}}</strong></span>
      <span *ngIf="row[col.boldField]">{{field | currency:Format.Currency}}</span>
    </div>
    <div *ngIf="col.format ===  TableFormat.Date">
      {{field | date: Format.Date }}
    </div>
    <div *ngIf="col.format === TableFormat.MediumDate">
      {{field | date: Format.MediumDate }}
    </div>
    <div *ngIf="col.format === TableFormat.NumberBold" [class]="ClassType.CurrencyInTable">
      <span *ngIf="!row[col.boldField]"><strong>{{field}}</strong></span>
      <span *ngIf="row[col.boldField]">{{field}}</span>
    </div>
    <div *ngIf="col.format === TableFormat.Percentage">
      {{field | percent}}
    </div>
    <div *ngIf="col.format === TableFormat.NumberAsPercentage">
      {{field}}%
    </div>
    <div *ngIf="col.format === TableFormat.Phone">
      {{field | phone}}
    </div>
    <div *ngIf="col.format === TableFormat.PostFix && col.postFix">
      {{field}}{{col.postFix}}
    </div>
    <div *ngIf="col.routeLink && col.format === TableFormat.RouteLink">
      <a [routerLink]="[col.routeLink,row[col.refIdField]]" routerLinkActive="active">
        {{field}}
      </a>
    </div>
    <div *ngIf="col.format === TableFormat.SsnMask">
      {{field | ssnMask}}
    </div>
    <div *ngIf="col.format === TableFormat.StringReplace">
      {{field | stringReplace : col?.labelChangeList}}
    </div>
    <div *ngIf="col.format === TableFormat.Time">
      {{field | date: Format.Time }}
    </div>
    <div *ngIf="col.format === TableFormat.NoTitleCase">
      {{field | titleCase : col?.noTitleCaseList}}
    </div>
    <div *ngIf="col.format === TableFormat.TitleCase">
      {{field | titleCase}}
    </div>
  </ng-container>
</div>

<ng-template #appRenderer>
  <ng-container *ngIf="col.app; else templateRenderer">
    <div *ngIf="col.app === TableApp.Expansion" style="text-align:center">
      <a [pRowToggler]="row">
        <i [ngClass]="expanded ? 'fa fa-sort-down' : 'fa fa-caret-right'"></i>
      </a>
    </div>
    <div *ngIf="col.app === TableApp.ApprovalStatus">
      <app-approvable-status [transaction]="col.transaction" [refId]="col.refIdField ? row[col.refIdField] : row.id"
                             [currentStatus]="col.currentStatus ? row[col.currentStatus] : row.currentStatus"
                             [hasSubmissionError]="row.hasSubmissionError">
      </app-approvable-status>
    </div>
    <div *ngIf="col.app === TableApp.ModHistory">
      <app-mod-history *ngIf="row[col.refIdField]" [componentId]="row[col.refIdField]" [type]="col.type"></app-mod-history>
    </div>
    <div *ngIf="col.app === TableApp.ContractInfo">
      {{row[col.field]}}
      <app-contract-info *ngIf="row[col.refIdField]" [contractId]="row[col.refIdField]" [orgIds]="orgIds"></app-contract-info>
    </div>
    <div *ngIf="col.app === TableApp.ClinInfo">
      {{row[col.field]}}
      <app-clin-info *ngIf="row[col.refIdField]" [clinId]="row[col.refIdField]" [orgIds]="orgIds"></app-clin-info>
    </div>
    <div *ngIf="col.app === TableApp.ProjectInfo">
      {{row[col.field]}}
      <app-project-info *ngIf="row[col.refIdField]" [projectId]="row[col.refIdField]" [orgIds]="orgIds"></app-project-info>
    </div>

  </ng-container>
</ng-template>

<ng-template #templateRenderer>
  <ng-container *ngIf="col.template ;else defaultRender" [ngTemplateOutlet]="col.template"
                [ngTemplateOutletContext]="{row: row, rowNode: rowNode, rowData: rowData, col: col, rowIndex: rowIndex, expanded:expanded}">
  </ng-container>
</ng-template>

<ng-template #defaultRender>
  <ng-container *ngVar="col.subfield ?  row?.[col.field]?.[col.subfield] : row?.[col.field] as field;">
    {{field}}
  </ng-container>
</ng-template>
